import React, { useState, useEffect } from 'react';
import { Card, CardHeader, Box, Text, IconButton, Textarea, Flex, Button } from '@chakra-ui/react';
import { Edit2 } from 'lucide-react';
import useServerApi from 'hooks/useServerApi';

const EditAgentGreeting = ({ agent, cardBg, cardBorder, onGreetingSaved }) => {
    const [{ post }] = useServerApi();
    const [isEditing, setIsEditing] = useState(false);
    const [greeting, setGreeting] = useState(agent?.initial_message || '');

    useEffect(() => {
        setGreeting(agent?.initial_message || '');
    }, [agent?.initial_message]);

    const updateGreeting = async (newGreeting) => {
        try {
            const [success] = await post('/rest_endpoints/agents/crud/update_agent_greeting', {
                agent_id: agent.id,
                greeting: newGreeting
            });
            if (success) {
                onGreetingSaved();
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error updating greeting:', error);
            return false;
        }
    };

    return (
        <Card bg={cardBg} border="1px solid" borderColor={cardBorder} borderRadius="lg" boxShadow="sm">
            <CardHeader display="flex" alignItems="center" justifyContent="space-between" py={3} px={4}>
                <Box>
                    <Text fontWeight="bold" fontSize="md">Greeting</Text>
                    <Text color="gray.500" fontSize="sm">
                        {agent?.initial_message || 'No greeting set. Click edit to add a greeting.'}
                    </Text>
                </Box>
                {!isEditing && (
                    <IconButton
                        aria-label="Edit"
                        icon={<Edit2 size={18} />}
                        variant="ghost"
                        colorScheme="purple"
                        size="sm"
                        onClick={() => setIsEditing(true)}
                    />
                )}
            </CardHeader>
            {isEditing && (
                <Box p={4}>
                    <Textarea
                        value={greeting}
                        onChange={(e) => setGreeting(e.target.value)}
                        placeholder="Enter greeting"
                    />
                    <Flex mt={2} justify="flex-end">
                        <Button size="sm" variant="ghost" onClick={() => { setIsEditing(false); setGreeting(agent?.initial_message || ''); }}>
                            Cancel
                        </Button>
                        <Button size="sm" colorScheme="purple" ml={2} onClick={async () => {
                            const success = await updateGreeting(greeting);
                            if (success) {
                                setIsEditing(false);
                            }
                        }}>
                            Save
                        </Button>
                    </Flex>
                </Box>
            )}
        </Card>
    );
};

export default EditAgentGreeting;